import { getFeatureFlag } from 'src/app/core/services/feature-flag-helpers';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { EWhiteLabelFont } from '../white-label-fonts.enum';
import { DEFAULT_ORIGINAL_FONT_FAMILY, DEFAULT_FONT_FAMILY } from './white-label-defaults.const';

export function getDefaultFontFamily(): EWhiteLabelFont {
  if (getFeatureFlag(EFeatureFlag.REBRAND)) {
    return DEFAULT_FONT_FAMILY;
  }

  return DEFAULT_ORIGINAL_FONT_FAMILY;
}
